import { ComponentConfig } from '@measured/puck';

import { Button } from '../../../../../components/atoms/button/button';
import { useReportContext } from '../../../renderer/report-context';
import * as contentUtils from '../../../utils/content';
import * as linkUtils from '../../../utils/links';

type ButtonBlockProps = {
  readonly appearance: 'primary' | 'secondary';
  readonly size: 'sm' | 'lg';
  readonly text: string;
  readonly link?: string;
  readonly externalLink?: string;
};

const BaseButton = ({ text, appearance, size, link, externalLink }: ButtonBlockProps) => {
  const { navigateToPath } = useReportContext();
  const navigateTo = () => {
    if (externalLink) return navigateToPath(externalLink);
    return link && navigateToPath(link);
  };
  return (
    <Button appearance={appearance} className="print:hidden" onClick={navigateTo} size={size}>
      {text}
    </Button>
  );
};

const ButtonBlock: ComponentConfig<ButtonBlockProps> = {
  defaultProps: {
    text: 'This is a button',
    appearance: 'secondary',
    size: 'sm',
  },
  fields: {
    text: {
      type: 'text',
    },
    appearance: {
      type: 'radio',
      options: [
        { label: 'Primary', value: 'primary' },
        { label: 'Secondary', value: 'secondary' },
      ],
    },
    size: {
      type: 'radio',
      options: [
        { label: 'Small', value: 'sm' },
        { label: 'Large', value: 'lg' },
      ],
    },
  },
  label: 'Button',
  render: BaseButton,
  resolveFields: ({ props }, { fields, appState }) => {
    const allLinks = contentUtils.getAllAnchors(appState.data.content);
    return {
      ...fields,
      ...linkUtils.createLinkFields(allLinks, props.link === linkUtils.EXTERNAL_OPTION_VALUE),
    };
  },
};

export { ButtonBlock };
